import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function StudioRental() {
  const [studios, setStudios] = useState([]);
  useEffect(() => { api.get("/studios").then((r) => setStudios(r.data)); }, []);

  return (
    <div data-testid="studios-page" className="pt-24">
      <section className="container mx-auto px-4 pt-16 pb-12">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-3">Studio Rental</div>
        <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none mb-6 max-w-4xl">
          Pro studios, <span className="text-gradient-animate">on demand.</span>
        </h1>
        <p className="text-lg text-[#52525B] max-w-2xl">
          Book a cyclorama, daylight loft or podcast booth — by the hour or the day.
          Lighting, audio and equipment included.
        </p>
      </section>

      <section className="container mx-auto px-4 pb-24">
        <div className="grid lg:grid-cols-2 gap-6">
          {studios.map((s) => (
            <Link to={`/studios/${s.id}`} key={s.id} data-testid={`studio-card-${s.id}`}
              className="group bg-white border border-zinc-200 hover:border-[#FF007F] rounded-2xl overflow-hidden transition">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={s.images[0]} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
              </div>
              <div className="p-7">
                <h3 className="font-display font-bold text-2xl mb-2 group-hover:text-[#FF007F] transition">{s.name}</h3>
                <p className="text-sm text-[#52525B] mb-4">{s.tagline}</p>
                <div className="flex flex-wrap gap-2 mb-5">
                  {s.amenities.slice(0, 4).map((a) => (
                    <span key={a} className="text-[10px] uppercase tracking-widest font-mono px-2 py-1 bg-zinc-100 rounded-full">{a}</span>
                  ))}
                </div>
                <div className="flex flex-wrap items-center justify-between gap-4 pt-5 border-t border-zinc-200">
                  <div>
                    <div className="font-display font-black text-2xl text-gradient-animate">₹{s.hourly_rate.toLocaleString()}<span className="text-sm font-medium text-zinc-500">/hr</span></div>
                    <div className="text-xs text-zinc-500 mt-1 flex items-center gap-1"><MapPin className="w-3 h-3" />{s.address}</div>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF007F]">
                    Book now <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
